import * as React from 'react';
import { Modal } from 'reactstrap';
import { getValue } from '@utils/lodash';
import './delete.scss';
interface IDeleteModalProps {
	isOpen: boolean;
	handleModal: () => void;
	handleSubmit: () => void;
	deleteValue: string;
}
const DeleteModal: React.FunctionComponent<IDeleteModalProps> = (props) => {
	return (
		<Modal
			isOpen={getValue(props, `isOpen`, '')}
			toggle={getValue(props, `isOpen`, '')}
			className="delete-modal-wrapper"
			centered
		>
			<section className="add-popup-wrapper">
				<div className="add-popup-wrapper__popup-1 p-5">
					<div className="add-popup-wrapper__form-group form-group">
						Are you sure, You want to delete{' '}
						<b>{getValue(props, `deleteValue`, '')}</b> ?
					</div>
					<div className="add-popup-wrapper__cta-wrapper">
						<button
							onClick={props.handleModal}
							className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
						>
							No
						</button>
						<button
							className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
							onClick={props.handleSubmit}
						>
							Yes
						</button>
					</div>
				</div>
			</section>
		</Modal>
	);
};

export default DeleteModal;
